import { useState, useEffect } from "react"

export const useWindowSize = (): { width: number; height: number } => {
  if (typeof window === "undefined" || !window.document) {
    return
  }

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth || undefined,
    height: window.innerHeight || undefined,
  })

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    // Add event listener
    window.addEventListener("resize", handleResize)

    // Call handler right away so state gets updated with initial window size
    handleResize()

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize)
  }, []) // Empty array ensures that effect is only run on mount

  return windowSize
}
